exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".S6Xus{margin-bottom:10px}.BDiu9{padding-top:20px}.BDiu9 ._1FK77:first-child h3{margin:0}.BDiu9 ._1FK77:nth-child(4)>h3{display:none;visibility:hidden}.BDiu9 ._1FK77 h3{text-transform:Uppercase;font-weight:700;font-size:12px;margin:20px 0 0}._1FK77:nth-child(2),._1FK77:nth-child(3),._1FK77:nth-child(4){text-align:left;border-left:1px solid #ccc;padding-left:30px;height:280px}._1FK77:nth-child(2) li a._1NJ0q,._1FK77:nth-child(3) li a._1NJ0q,._1FK77:nth-child(4) li a._1NJ0q{text-align:left}.BDiu9 ul li:nth-child(odd){padding-top:10px;padding-bottom:10px}a._1NJ0q:active,a._1NJ0q:link,a._1NJ0q:visited{color:#fff;text-decoration:none;font-size:11px}a._1NJ0q:hover,a._1NJ0q:visited:hover{color:#000;text-decoration:none}h3{color:#fff}", ""]);

// exports
exports.locals = {
	"logo": "S6Xus",
	"root": "BDiu9",
	"col": "_1FK77",
	"link": "_1NJ0q"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/FooterNavigation/FooterNavigation.css
// module id = 1103
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13